export const CLIENT_CODE = 'clientCode';
export const USERNAME = 'username';
export const SESSION_KEY = 'sessionKey';
export const EMPLOYEE_ID = 'employeeID';
export const USER_TOKEN = 'userToken';
export const INSTALLER_CONFIG = 'installerConfig';
export const SERVICE_ENDPOINTS = 'REDUX-service-endpoints';

export const bootstrapVariants = {
  primary: 'primary',
  secondary: 'secondary',
  success: 'success',
  danger: 'danger',
  warning: 'warning',
  info: 'info',
  light: 'light',
  dark: 'dark',
};

export const ALL_VERSIONS_URL = 'https://app-ver.erply.com';
